export enum GroupType {
  Organization = 1,
  Application = 2
}

export const groupTypeNameShort: { [key in GroupType]: string } = {
  [GroupType.Organization]: 'Org',
  [GroupType.Application]: 'App'
}

export function groupTypeMissingDataMessageFor(groupType: GroupType, searchByOrg?: boolean): string {
  return {
    [GroupType.Application]: 'No app groups in the app. Please go to Groups & Permissions to create app groups.',
    [GroupType.Organization]: searchByOrg ?
                              'No org groups are created. Please go to Manage Members to create org groups.' :
                              'No org groups are assigned. Please go to Manage Members to add org groups.',
  }[groupType];
}